<template>
    <div>
      <v-tabs v-model="selectedTab" color="#8C1E81" dark slider-color="#2A2065" show-arrows>
        <v-tab v-for="tab in tabs" :key="tab.key">
          {{tab.name}}
        </v-tab>
      </v-tabs>
      <div>
        <template v-if="$vuetify.breakpoint.smAndDown">
          <members-small :category="selectedTab"></members-small>
        </template>
        <template v-else>
          <members-medium :category="selectedTab"></members-medium>
        </template>
      </div>
    </div>
</template>

<script>
import { mapActions } from 'vuex'
import MembersMedium from '@/components/MembersMedium.vue'
import MembersSmall from '@/components/MembersSmall.vue'

export default {
  name: 'Search',
  components: {
    'members-medium': MembersMedium,
    'members-small': MembersSmall
  },
  data: () => ({
    selectedTab: null,
    loading: false,
    total: 0,
    page: 0,
    items: [],
    search: null,
    tabs: [
      {
        name: 'All',
        key: 'all'
      },
      {
        name: 'Agents & Advisors',
        key: 'agents-and-advisors'
      },
      {
        name: 'Landlords & Investors',
        key: 'landlords-and-investors'
      },
      {
        name: 'Planning & Technical',
        key: 'planning-and-technical'
      },
      {
        name: 'Occupier',
        key: 'occupier'
      }
    ]
  }),
  created () {
    this.setTitle({ title: 'Search' })
  },
  methods: {
    ...mapActions(
      'application', {
        setTitle: 'setTitle'
      }
    )
  },
  watch: {
  }
}
</script>

<style scoped>

</style>
